import React, { Component } from 'react'
import { connect } from 'react-redux';

import { customSecondsElapsedForIntervalObservation } from '../actions/BehaviourDataActions'

class CountdownTimerForInterval extends Component {

    componentDidMount = () => {
        this.props.observationIntervalIncrementerTwo.map((obj, index) => {
            return clearInterval(this.props.observationIntervalIncrementerTwo[0]);
        })
        if (this.props.isStart) {
            this.props.customSecondsElapsedForIntervalObservation("mount")
        }
    } 

    componentWillUnmount = () => {
        this.props.observationIntervalIncrementerOne.map((obj, index) => {
            return clearInterval(this.props.observationIntervalIncrementerOne[0]);
        })
        this.props.customSecondsElapsedForIntervalObservation("unmount")
    }

    getSeconds = (observationIntervalSecondsElapsed) => {
        const roundedSeconds = Math.round(observationIntervalSecondsElapsed);
        return ('0' + roundedSeconds % 60).slice(-2)
    }

    getMinutes = (observationIntervalSecondsElapsed) => {
        return Math.floor(observationIntervalSecondsElapsed  / 60)
    }

    render() {
        return (
            <div>
                {this.getMinutes(this.props.observationIntervalSecondsElapsed)}:{this.getSeconds(this.props.observationIntervalSecondsElapsed)}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        isStart: state.patientRecordIntervalCustomReducer.isStart,
        observationIntervalSecondsElapsed: state.patientRecordIntervalCustomReducer.observationIntervalSecondsElapsed,
        observationIntervalIncrementerOne: state.patientRecordIntervalCustomReducer.observationIntervalIncrementerOne,
        observationIntervalIncrementerTwo: state.patientRecordIntervalCustomReducer.observationIntervalIncrementerTwo
    }
}

export default connect(mapStateToProps, {customSecondsElapsedForIntervalObservation})(CountdownTimerForInterval);




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/CountDownTimerForInterval.js